"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ScimLogSearchServiceQueryParams", {
    enumerable: true,
    get: function() {
        return ScimLogSearchServiceQueryParams;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../base");
const ScimLogSearchServiceQueryParams = _base.BaseSearchServiceQueryParams.extend({
    service: _zod.z.literal("scim_log"),
    format: _zod.z.literal("csv").optional(),
    // Different filters based on `searchFields()`
    type_eq: _zod.z.string().optional(),
    type_in: (0, _utilsisomorphic.transformStringToArray)(_models.ScimResourceLogActionType.array().or(_models.ScimResourceLogActionType)).optional(),
    status_eq: _zod.z.string().optional(),
    status_in: (0, _utilsisomorphic.transformStringToArray)(_models.ScimResourceLogStatus.array().or(_models.ScimResourceLogStatus)).optional(),
    day_count_lt: _zod.z.string().optional(),
    user_email_eq: _zod.z.string().optional(),
    user_email_re: _zod.z.string().optional(),
    id_in: (0, _utilsisomorphic.transformStringToArray)(_zod.z.array(_utilsisomorphic.transformObjectId).or(_utilsisomorphic.transformObjectId)).optional(),
    id_nin: (0, _utilsisomorphic.transformStringToArray)(_zod.z.array(_utilsisomorphic.transformObjectId).or(_utilsisomorphic.transformObjectId)).optional(),
    id_eq: _utilsisomorphic.transformObjectId.optional(),
    id_ne: _utilsisomorphic.transformObjectId.optional()
});
